import BarsIcon from 'src/app/assets/icons/ico-bars.svg'
import { isAuthenticatedPlayer } from 'src/types/domain/Player'
import { getCurrencySymbol } from 'src/utils/getCurrencySymbol'
import { useGetCurrentPlayer } from 'src/store/player'
import { useGetCurrentGame, useGetGameConfig } from 'src/store/game'
import { isKnownGameConfig } from 'src/types/domain/GameConfig'
import { isMarbleGame } from 'src/types/domain/Game'
import { isCrashGameType } from 'src/utils/gameTypeUtils'
import { useGetHasInitialBalanceAnimationOccurred, useUIActions } from 'src/store/ui'
import { Balance } from './Balance'

type Props = Readonly<{
  onToggleSidebar: () => void
  isSidebarOpen: boolean
}>

export function BalanceContainer({ onToggleSidebar, isSidebarOpen }: Props) {
  const player = useGetCurrentPlayer()
  const gameConfig = useGetGameConfig()
  const currentGame = useGetCurrentGame()
  const hasInitialBalanceAnimationOccurred = useGetHasInitialBalanceAnimationOccurred()
  const uiActions = useUIActions()

  if (!isAuthenticatedPlayer(player)) {
    return null
  }

  // Chip-placement mode shows the balance in the bottom chip-stats overlay
  // (see page.tsx), so we drop the top-right balance pill but keep the
  // sidebar toggle as a compact icon-only button. Crash games use the same
  // overlay (CrashChipPanel reports its stats up to the page), so they get
  // the same compact toolbar — gated on the gameType, mirroring the
  // `isCrashGame` panel selection in page.tsx.
  const isCrashGame = isMarbleGame(currentGame) && isCrashGameType(currentGame.track.gameType)
  if ((isKnownGameConfig(gameConfig) && gameConfig.bettingMode === 'chip-placement') || isCrashGame) {
    return (
      <div className="toolbar-player toolbar-player--compact">
        <button
          type="button"
          className={`toolbar-button toolbar-button--icon ${isSidebarOpen ? 'active' : ''}`}
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          <span className="hamburger-icon">
            <BarsIcon />
          </span>
        </button>
      </div>
    )
  }
  const currentCurrency = getCurrencySymbol(player.balance.currency)
  const currentBalance = player.balance.amount

  return (
    <Balance
      afterAnimationCallback={() => {
        uiActions.initialBalanceAnimationOccurred()
      }}
      balanceLoaded={player.balanceLoaded}
      currentBalance={currentBalance}
      currentCurrency={currentCurrency}
      initialBalance={hasInitialBalanceAnimationOccurred ? currentBalance : 0}
      isSidebarOpen={isSidebarOpen}
      onToggleSidebar={onToggleSidebar}
    />
  )
}
